import { registerI18nResources } from '@mc/i18n'

import enUS from './locales/en-US.json'

export const HP_SUBHEADER_COPY_I18N_NAMESPACE =
  '@mc/next/experiments/pen-5478_v1_hp_subheader_copy'

export const i18nInstance = registerI18nResources({
  namespace: HP_SUBHEADER_COPY_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
